// pages/User/components/UserStats.jsx
import { BsFileEarmarkText } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
// user,
const UserStats = ({ totalAds }) => {
  const { t } = useTranslation();

  return (
    <div className='rounded-xl bg-white p-6 shadow-lg'>
      <div className='mb-6'>
        <h2 className='text-xl font-bold text-gray-800'>{t('userStatistics')}</h2>
      </div>

      <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'>
        <div className='group relative overflow-hidden rounded-xl bg-gradient-to-br from-primary-yellow to-yellow-400 p-6 transition-all duration-300 hover:shadow-xl'>
          <div className='absolute right-0 top-0 -mr-10 -mt-10 h-20 w-20 rounded-full bg-white opacity-10'></div>
          <div className='relative z-10'>
            <div className='mb-3 flex items-center justify-between'>
              <div className='flex h-12 w-12 items-center justify-center rounded-xl bg-white bg-opacity-30'>
                <BsFileEarmarkText className='text-2xl text-gray-800' />
              </div>
            </div>
            <p className='mb-1 text-sm font-medium text-gray-700'>{t('totalAds')}</p>
            <p className='text-3xl font-bold text-gray-800'>{totalAds}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStats;
